import { useTranslations } from 'next-intl'

interface IProps {
	languages: string[]
}

export default function AEmployeeHeroInfoLanguages({ languages }: IProps) {
	const tCommon = useTranslations('common')
	const t = useTranslations('pages.team_detail.hero')

	const getLocaleName = (code: string) => {
		const translated = tCommon(`languages.${code}`)

		if (translated.includes('languages.')) {
			return code
		}

		return translated
	}

	return (
		<>
			{languages?.length > 0 ? (
				<div className='page_content reset_margins nobalance mgt-30'>
					<p className='font-medium'>
						{t('language', {
							language: languages.map(language => getLocaleName(language)).join(', ')
						})}
					</p>
				</div>
			) : null}
		</>
	)
}
